// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
.countdown-title {
  font-weight: 400;
}

.countdown-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.countdown-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #212529;
  flex: 1;
}
.countdown-unit:last-child {
  border-right: none;
}

.countdown-number {
  font-size: 4rem;
  line-height: 1;
  margin: 0 0 8px 0;
  padding: 0;
}

.countdown-text {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/storyblok/components/storyblok-countdown/storyblok-countdown.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,OAAA;AADF;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAFF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n.countdown-title {\n  font-weight: 400;\n}\n\n.countdown-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n}\n\n.countdown-unit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 1px solid #212529;\n  flex: 1;\n\n  &:last-child {\n    border-right: none;\n  }\n}\n\n.countdown-number {\n  font-size: 4rem;\n  line-height: 1;\n  margin: 0 0 8px 0;\n  padding: 0;\n}\n\n.countdown-text {\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
